import styled from "styled-components";
export const GlobalAdminManageUserViewParent = styled.div ``;
